import type { DatapointOptions, CustomData, InternalDatapointOptions } from 'owa-analytics-types';
import { lazyLogUsage } from '../lazyFunctions';
import { addStackTraceToEvent } from 'owa-analytics-utils/lib/addStackTraceToEvent';
import { yieldNow } from 'owa-task-queue/lib/schedule';
import type { AnalyticsCoreEventNames, AnalyticsEventNames } from 'owa-analytics-events';
import type { MailboxInfo } from 'owa-client-types';

const GREY_ERROR_TABLE = 'client_grey_error';

export async function logUsage<TKeys extends string = string>(
    eventName: AnalyticsEventNames | AnalyticsCoreEventNames,
    mailbox: MailboxInfo | undefined,
    customData?: CustomData<TKeys>,
    options?: DatapointOptions,
    shouldYield?: boolean
): Promise<void> {
    if (shouldYield) {
        yieldNow('logUsage');
    }

    const tableOverride = (options as InternalDatapointOptions)?.isGreyError
        ? GREY_ERROR_TABLE
        : undefined;
    // Add original stack trace
    const datapointOptions = options ?? {};
    addStackTraceToEvent(datapointOptions);

    return lazyLogUsage.importAndExecute(
        eventName,
        mailbox,
        customData,
        datapointOptions,
        tableOverride
    );
}
